<template>
  <div class="invoice-red">
    <header>
      <h6>查询蓝字发票</h6>
    </header>
    <main>
      <div class="card">
        <van-field v-model.trim="invoiceInfo.invoiceCode" label="发票代码" placeholder="请输入发票代码" required @input="(e) => changeInvoiceInfo('invoiceCode', e)" />
        <van-field v-model.trim="invoiceInfo.invoiceNo" label="发票号码" placeholder="请输入发票号码" required @input="(e) => changeInvoiceInfo('invoiceNo', e)" />
      </div>
    </main>
    <footer>
      <MainButton
        :handleClick="handleGetInvoiceInfo"
      >
        <span>查询发票信息</span>
      </MainButton>
    </footer>
  </div>
</template>

<script>
import { Field, Dialog, Notify, Toast } from 'vant'
import { aesDoDecrypt } from '@utils/basicUtil'
import MainButton from '@/components/MainButton/index.vue'
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  components: {
    MainButton,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('invoiceRedModel', ['invoiceInfo'])
  },
  mounted () {
    const { key } = this.$route.query
    if (key) {
      const info = aesDoDecrypt(key)
      this.changeInvoiceInfo('invoiceCode', info.invoiceCode)
      this.changeInvoiceInfo('invoiceNo', info.invoiceNo)
    }
  },
  activated () {
    const { key } = this.$route.query
    if (key) {
      const info = aesDoDecrypt(key)
      this.changeInvoiceInfo('invoiceCode', info.invoiceCode)
      this.changeInvoiceInfo('invoiceNo', info.invoiceNo)
    }
  },
  methods: {
    ...mapActions('invoiceRedModel', ['getInvoiceInfo']),
    ...mapMutations('invoiceRedModel', ['setInvoiceInfoByField']),
    changeInvoiceInfo (field, value) {
      this.setInvoiceInfoByField({ field, value })
    },
    async handleGetInvoiceInfo () {
      // 查询发票详情，根据代码号码
      if (!this.invoiceInfo.invoiceCode) {
        Notify({ type: 'danger', message: '发票代码必填' })
        return
      }
      if (!this.invoiceInfo.invoiceNo) {
        Notify({ type: 'danger', message: '发票号码必填' })
        return
      }
      Toast.loading({
        message: '查询中...',
        duration: 0
      })
      try {
        const flag = await this.getInvoiceInfo()
        if (flag && flag.showDialog) {
          Dialog.confirm({
            title: '暂不支持专票和数电红冲',
            showCancelButton: false,
            confirmButtonColor: '#3378FF',
            message: '移动端暂时不支持专票和数电红冲操作，烦请移步电脑端进行红冲。'
          }).then(() => {

          })
          return
        }
        if (flag) {
          this.$router.push('/invoice-red/opening')
        }
      } catch (error) {
      } finally {
        Toast.clear({
          clearAll: true
        })
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less" />
